<template>
	<validation-observer ref="observer" v-slot="{ handleSubmit }">
		<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">

			<validation-provider v-slot="validationContext" name="Project Name" v-bind:rules="{ required: true }" vid="name">
				<b-form-group ref="project-name" label="Name" label-for="project-name">
					<b-form-input id="project-name" v-model="form_data.name" v-bind:state="getValidationState( validationContext )"></b-form-input>
					<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
				</b-form-group>
			</validation-provider>

			<validation-provider v-slot="validationContext" name="Customer" v-bind:rules="{ required: true }" vid="customer">
				<b-form-group ref="project-client" label="Client" label-for="project-client">
					<autocomplete id="project-client" v-model="form_data.customer" endpoint="/customers/search/{token}" label-key="name" v-bind:validation-context="validationContext"></autocomplete>
				</b-form-group>
			</validation-provider>

			<b-form-row>
				<b-col md="6">

					<b-form-group ref="project-start-date" label="Start" label-for="project-start-date">
						<b-form-datepicker id="project-start-date" v-model="form_data.start_date" nav-button-variant="light" v-bind:date-format-options="date_picker_options"></b-form-datepicker>
					</b-form-group>

				</b-col>
				<b-col md="6">

					<b-form-group ref="project-end-date" label="End" label-for="project-end-date">
						<b-form-datepicker id="project-end-date" v-model="form_data.end_date" nav-button-variant="light" v-bind:date-format-options="date_picker_options"></b-form-datepicker>
					</b-form-group>

				</b-col>
			</b-form-row>

			<b-button :disabled="project.locked" block type="submit" variant="light">Update Project</b-button>

		</b-form>
	</validation-observer>
</template>

<script>
import { PROJECT_SAVE } from '../../store/actions/project'
import Autocomplete from '../../components/Autocomplete'

export default {
	name: 'ProjectDetails',

	props: ['id'],

	components: { Autocomplete },

	computed: {
		project: function () { return this.$store.state.project.project }
	},

	data () {
		return {
			form_data: {
				name: '',
				customer: {},
				start_date: null,
				end_date: null
			},

			date_picker_options: {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric'
			}
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		onSubmit () {
			this.$store.dispatch(PROJECT_SAVE, this.form_data)
		}
	},

	watch: {
		project: {
			handler: function (value) { Object.assign(this.form_data, value) },
			immediate: true
		}
	}
}
</script>
